<template>
    <div class="header-root">
        <img alt="exploration logo" src="../assets/exploration-logo.png">
        <span class="header-title">seismic viewer</span>
        
        <div class="header-spinner">
            <BusySpinner />
        </div>

        <div class="profile-section" v-show="isSignedIn">
            <span>Welcome, {{profileName}}</span>            
        </div>
        
    </div>
</template>

<style>
    .header-root {
        display: grid;
        grid-template-columns: min-content min-content 100px 1fr;
        border-bottom: 1px solid #D9D9D9;
        align-items: center;
    }

    .header-title {
        white-space: nowrap;
        font-family: 'GothamBold', 'Arial Bold', sans-serif;
        font-size: 2em;
        color: #009DD9;
        margin-left: 0.4em;
    }

    .header-spinner {
        margin-left: 2em;
    }

    .profile-section {
        color: #0b2d71;
        font-family: GothamBold,Arial,sans-serif;
        font-weight: normal;
        font-size: 0.9em;
        justify-self: right;
        margin-right: 1em;
    }

</style>

<script lang="ts">
    import { defineComponent } from 'vue';
    import BusySpinner from "./BusySpinner.vue";
    import { getUserName } from "../common/CvxAuth";

    export default defineComponent({
        name: 'HeaderView',
        components: {
            BusySpinner
        },
        data() {
            return {
                profilePic: "data:image/png;base64,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",
                profileName: getUserName() || "anonymous",
                isSignedIn: true
            };
        },

        created() {
        },

        mounted() {
         
        }

    });
</script>
